import { createContext } from 'react';
import type { AppPlatform, ChatAppApiClient, GroupFeaturesContextValue } from '@trinity/chat';
import { GenAIExternalPlatform } from '@trinity/management-app-client';
import type { IChatAPISessionManager } from '../Chat.APIClient/api.session';

export const ChatApiClientContext = createContext<ChatAppApiClient>(undefined);

export const SessionManagerContext = createContext<IChatAPISessionManager | undefined>(undefined);

export const GroupFeaturesContext = createContext<GroupFeaturesContextValue | undefined>(undefined);

export const ChatAppPlatformContext = createContext<GenAIExternalPlatform | undefined>(
  GenAIExternalPlatform.GenAIPlatform
);
export const AppPlatformContext = createContext<AppPlatform | undefined>('microsite');
export const IsDemoEnvContext = createContext<boolean | undefined>(false);
export const ChatAppSessionAvailableContext = createContext<boolean>(false);

export const FullScreenChatBasePathContext = createContext<string>('/chat');

export const WebsocketConfigContext = createContext<
  | {
      baseUrl: string;
      socketPath: string;
    }
  | undefined
>(undefined);

export const ChatApiConfigContext = createContext<{
  baseUrl: string;
}>({
  baseUrl: '',
});

type ErrorContext = {
  tags?: Record<string, string | number | boolean>;
  extra?: Record<string, any>;
  level?: 'fatal' | 'error' | 'warning' | 'info' | 'debug';
  fingerprint?: string[];
  contexts?: Record<string, any>;
};
export type ChatLogger = {
  addBreadcrumb: (breadcrumb: { message?: string }) => void;
  captureMessage: (message: string) => void;
  captureException: (error: any, context?: ErrorContext) => void;
  setContext(
    name: string,
    context: {
      [key: string]: any;
    }
  ): void;
};
export const ChatLoggerContext = createContext<ChatLogger>({
  addBreadcrumb: () => {},
  captureMessage: () => {},
  captureException: () => {},
  setContext: () => {},
});
